export default __webpack_public_path__ + "static/media/Knife_1.c16b538f.png";